module.exports = (__webpack_require__(0))(39);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/widgets/MarkdownWidget.js from dll-reference girder_lib
// module id = 130
// module chunks = 0